import { ActionTableColumnsType } from '../../../types/table/ActionTableColumnsType';

export const GROUP_TABLE_COLUMNS: ActionTableColumnsType[] = [
  { label: 'グループ名', key: 'name', sortable: false, filterable: true },
  { label: 'グループID', key: 'code', sortable: false, filterable: true },
  { label: '説明', key: 'description', sortable: false, filterable: false },
  { label: '作成日時', key: 'createdAt', sortable: true, filterable: false },
  { label: '更新日時', key: 'updatedAt', sortable: true, filterable: false },
  { label: '設定', key: 'action', sortable: false, filterable: false },
];
